import { A } from '@adornis/base/env-info.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { selectionSet, type BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { Participation } from '../entities/Participation.js';
import type { ParticipationWorkshop } from '../entities/ParticipationWorkshop.js';
import { Appointment } from '../entities/appointment.js';
import { UserStammdaten } from '../entities/stammdaten.js';
import { Suspension } from '../entities/suspension.js';
import { User } from '../entities/user.js';

@Entity()
export class UserDataview extends AdornisEntity {
  static override _class = 'UserDataview';

  static override resolveID(entity: UserDataview): string {
    if (!entity._id) return (entity._id = A.getGloballyUniqueID());
    return entity._id;
  }

  @validate(nonOptional())
  @Field(type => String)
  _id!: string;

  @validate(nonOptional())
  @Field(type => User)
  user!: User;

  @Field(type => UserStammdaten)
  userStammdaten!: UserStammdaten;

  @validate(nonOptional())
  @Field(type => [Participation])
  participations!: Participation[] | ParticipationWorkshop[];

  public static get neededGqlFields(): BaseQLSelectionSet<UserDataview> {
    return {
      _id: 1,
      _class: 1,
      user: {
        _id: 1,
        _class: 1,
        email: 1,
        username: 1,
        firstName: 1,
        lastName: 1,
        suspentions: Suspension.allFields,
      },
      userStammdaten: selectionSet(() => UserStammdaten, 3),
      participations: {
        _id: 1,
        _class: 1,
        waitingListPlace: 1,
        nachrueckPriority: 1,
        product: {
          name: 1,
          prices: { unitAmount: 1 },
          sortingWeight: 1,
          hasPrice: 1,
          category: { name: 1 },
          institutionID: 1,
          timeframeID: 1,
          timeframe: { _id: 1, name: 1 },
          productCopyID: 1,
          isLDAPOnly: 1,
          publishDate: 1,
          topic: 1,
          language: 1,
          presenceType: 1,
          isCanceled: 1,
          capacity: 1,
          appointments: selectionSet(() => Appointment, 1),
        },
      },
    } as const satisfies BaseQLSelectionSet<UserDataview>;
  }
}
